import { useEffect, useMemo } from 'react'
import prop from 'lodash/fp/prop'
import useStoreSelector from './useStoreSelector'

const selectFormatOptions = prop('formatOptions')

export default function useDateTimeFormat() {
  const _formatOptions = useStoreSelector('appConfig', selectFormatOptions)

  const formatOptions = useMemo(() => {
    const { dateFormat, timeFormat } = _formatOptions
    return {
      dateFormat,
      timeFormat,
      dateTimeFormat: {
        value: `${dateFormat.value} ${timeFormat.value}`,
        altValue: `${dateFormat.altValue} ${timeFormat.altValue}`
      }
    }
  }, [_formatOptions])

  return formatOptions
}

/**
 * Refresh AG Grid cells when date/time formatting options change.
 * @param {*} gridApi AG Grid API object
 */
export function useRefreshCellsOnFormatChange(gridApi) {
  const formatOptions = useDateTimeFormat()

  useEffect(() => {
    gridApi?.api.refreshCells({ force: true })
  }, [formatOptions])
}
